export const SEARCH_SELECT_LIMIT = 15;
